import React from 'react';

/**
 * App-boot loading screen — "Materialize + light sweep".
 *
 * Shown ONLY while auth claims / shell data resolve (ProtectedRoute,
 * AppLayout). Page-level loading must use skeletons (SkeletonLoader.tsx),
 * never this screen.
 *
 * Composition (keyframes + classes in index.css):
 *  - aurora: blurred brand-colour light drifting behind the glyph
 *  - glyph: transparent V (public/valutten-v.png, generated by
 *    scripts/branding/extract-valutten-v.py) — blur-bloom entrance, then breathe
 *  - sweep: specular highlight masked BY the glyph, so light travels inside it
 *  - wordmark: rendered text with silver gradient + periodic shine
 */
const Loading: React.FC = () => {
  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-900 overflow-hidden">
      <div className="relative text-center">
        {/* Aurora backdrop */}
        <div
          aria-hidden
          className="boot-aurora absolute left-1/2 -translate-x-1/2 -top-16 h-80 w-96 rounded-full blur-3xl pointer-events-none"
          style={{
            background:
              'radial-gradient(circle at 28% 42%, rgba(34,211,238,0.55), transparent 55%), ' +
              'radial-gradient(circle at 72% 45%, rgba(236,72,153,0.5), transparent 55%), ' +
              'radial-gradient(circle at 50% 72%, rgba(168,85,247,0.45), transparent 60%)',
          }}
        />
        <div className="relative inline-block">
          <img
            src="/valutten-v.png"
            alt="VALUTTEN"
            width={637}
            height={562}
            className="boot-glyph h-28 w-auto mx-auto"
          />
          {/* Specular sweep, masked to the glyph shape */}
          <div
            aria-hidden
            className="boot-sweep absolute inset-0 pointer-events-none"
            style={{
              WebkitMaskImage: `url(${process.env.PUBLIC_URL}/valutten-v.png)`,
              maskImage: `url(${process.env.PUBLIC_URL}/valutten-v.png)`,
            }}
          />
        </div>
        <div className="boot-wordmark relative mt-6 text-xl font-extrabold">VALUTTEN</div>
        <p className="boot-caption relative text-gray-500 text-sm mt-4">Loading…</p>
      </div>
    </div>
  );
};

export default Loading;
